<template>
    <div id="viphome" class="container-fluid text-center">
        <Navigator></Navigator>
        <div class="row" id="placeholderimg">
            <div class="p-4 col-12 col-lg-5 mx-auto">
                <div class="title titlemine p-4">
                    <img src="../../assets/images/kalamaio-logo-light-72.png"/>
                    <h5 class="p-4"><strong>Your Kalameetings</strong></h5>
                    <span>Manage kalameetings you created</span>
                    <router-link :to="{path: '/create-kalameeting'}">
                        <b-button class="mt-3" pill>
                            Create a new Kalameeting
                        </b-button>
                    </router-link>
                </div>
                <KalameetingList :kalameetings="mykalameetings"></KalameetingList>
                <div class="title titlebooked p-4 mt-5">
                    <h5 class="p-4"><strong>Booked Kalameetings</strong></h5>
                    <span>See kalameetings you have booked</span>
                </div>
                <KalameetingList :kalameetings="bookedkalameetings"></KalameetingList>
            </div>
            <div class="p-4 col-12 col-lg-6  mx-auto">
                <div class="title p-4">
                    <h5 class="p-4"><strong>All Kalameetings</strong></h5>
                    <span>Check other kalameetings you can join</span>
                </div>
                <KalameetingList :kalameetings="allkalameetings"></KalameetingList>
            </div>
        </div>
    </div>
</template>

<style>
    .title {
        background: #06424dee;
        border-radius: 20px 20px 0 0;
    }
    .titlemine {
        background: #FF0066ee;
    }
    .titlebooked {
        background: #ffc000ee;
    }
    .title h5 {
        color:white;
        display: inline;
        vertical-align: middle;
        height: 100%;
    }

    .title span {
        color: white;
        display: block;
    }
    .title img {
        height: 30px;
        width: 30px;
        display: inline;
    }
    #viphome {
        background-image: url("../../assets/images/texture.png");
        background-repeat: no-repeat;
        background-size: cover;
        background-attachment: fixed;
        min-height: 100%;
    }
</style>
<script>
import firebase from '../../firebase';
import Navigator from '../../components/Navigator.vue';
import KalameetingList from '../../components/KalameetingList.vue';

export default {
    data() {
        return {
            mykalameetings: [],
            allkalameetings: [],
            bookedkalameetings: []
        };
    },
    created() {
        firebase.kalameetingCollection.orderBy('date', 'asc')
            .onSnapshot((querySnapshot) => {
                querySnapshot.forEach((doc) => {
                    const kalameeting = doc.data();
                    kalameeting.id = doc.id;
                    if (new Date() < new Date(kalameeting.date)) {
                        if (kalameeting.owner.uid === this.$store.state.currentUser.uid) {
                            this.mykalameetings.push(kalameeting);
                        } else {
                            this.allkalameetings.push(kalameeting);
                        }
                    }
                });
            });
    },
    components: {
        Navigator,
        KalameetingList
    }
};
</script>
